import { setPost, setPostsCurrentPage } from "../slices/postSlice";

import { message } from "antd";
import { logoutReducer } from "../slices/authSlice";
import API from "../api";
import Swal from "sweetalert2";

export const changePostsCurrentPage = (page) => async (dispatch, getState) => {
  dispatch(setPostsCurrentPage(page));
};

export const createPost =
  (payload, imagePayload) => async (dispatch, getState) => {
    try {
      const token = getState().user.token;
      const headers = { Authorization: "Bearer " + token };
      const response = await API.post(
        `${process.env.REACT_APP_BACKEND_API}posts`,
        payload,
        { headers: headers },
      );

      if (response.status === 200) {
        if (imagePayload) {
          dispatch(postImageUpload(imagePayload, response.data.id)).then(
            (res) => {
              Swal.fire({
                icon: "success",
                text: "You have successfully Added the Post!",
                showConfirmButton: false,
                timer: 2000,
                timerProgressBar: true,
              });
              dispatch(changePostsCurrentPage(1));
              dispatch(fetchPosts(getState().postsData.currentPage));
            },
          );
        } else {
          Swal.fire({
            icon: "success",
            text: "You have successfully Added the Post!",
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
          });
          dispatch(changePostsCurrentPage(1));
          dispatch(fetchPosts(getState().postsData.currentPage));
        }
      } else {
        //message.info("Please try again, post not added!");
        Swal.fire({
          icon: "error",
          text: "Post was not added. Please try again!",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });
      }
    } catch (err) {
      message.error(err.response.data.message);
      throw new Error(err);
    }
  };

export const fetchPosts = (page) => async (dispatch, getState) => {
  try {
    const token = getState().user.token;

    const response = await API.get(
      `${process.env.REACT_APP_BACKEND_API}v3/posts?country=KS&page=${
        page - 1
      }`,
      {
        headers: { Authorization: "Bearer " + token },
      },
    );
    console.log(response.data);
    dispatch(setPost(response.data));
  } catch (err) {
    if (err.response.data.code === 401) {
      dispatch(logoutReducer());
    }
    throw new Error(err);
  }
};

export const postImageUpload = (payload, id) => async (dispatch, getState) => {
  try {
    const token = getState().user.token;
    const headers = {
      Authorization: "Bearer " + token,
    };
    const response = await API.post(
      `${process.env.REACT_APP_BACKEND_API}upload/${id}`,
      payload,
      { headers: headers },
    );
    console.log(response);
  } catch (err) {
    throw new Error(err);
  }
};

export const deletePost = (payload) => async (dispatch, getState) => {
  try {
    const token = getState().user.token;
    const headers = {
      Authorization: "Bearer " + token,
    };
    const response = await API.delete(
      `${process.env.REACT_APP_BACKEND_API}posts/${payload}`,
      { headers },
    );
    if (response.status === 200) {
      //message.success("Posti eshte fshire!");
      Swal.fire({
        icon: "success",
        //title: "Success!",
        text: "You have successfully Deleted the Post!",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
      });
      dispatch(fetchPosts(getState().postsData.currentPage));
    }
  } catch (err) {
    throw new Error(err);
  }
};

export const updatePost =
  (payload, imagePayload) => async (dispatch, getState) => {
    console.log("OK asd", getState().postsData.currentPage);
    try {
      const token = getState().user.token;
      const headers = {
        Authorization: "Bearer " + token,
      };

      const response = await API.put(
        `${process.env.REACT_APP_BACKEND_API}posts/${payload.id}`,
        payload,
        { headers },
      );

      if (response.status === 200) {
        console.log("___________________________________", response);
        if (imagePayload) {
          dispatch(postImageUpload(imagePayload, payload.id)).then((res) => {
            Swal.fire({
              icon: "success",
              text: "You have successfully Edited the Source!",
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true,
            });
            dispatch(fetchPosts(getState().postsData.currentPage));
          });
        } else {
          Swal.fire({
            icon: "success",
            text: "You have successfully Edited the Source!",
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
          });
          dispatch(fetchPosts(getState().postsData.currentPage));
        }
      } else {
        //message.info("Please try again!");
        Swal.fire({
          icon: "error",
          text: "Source was not edited. Please try again!",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });
      }
    } catch (err) {
      if (err.response.status >= 400) {
        //message.info("Posti nuk eshte ndryshu!");
        Swal.fire({
          icon: "error",
          text: "Source was not edited. Please try again!",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });
      }
      throw new Error(err);
    }
  };

export const searchPosts = (page, search) => async (dispatch, getState) => {
  try {
    const token = getState().user.token;

    const response = await API.get(
      `${process.env.REACT_APP_BACKEND_API}posts?page=${
        page - 1
      }&title=${search}`,
      {
        headers: { Authorization: "Bearer " + token },
      },
    );
    console.log(response.data);
    dispatch(setPost(response.data));
  } catch (err) {
    if (err.response.data.code === 401) {
      dispatch(logoutReducer());
    }
    throw new Error(err);
  }
};
